import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
      pxCorrection
    } = config;
    this.trigger = accordions;
    this.pxCorrection = pxCorrection;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      const accordionClass = el.getAttribute('class').split(' ')[0];

      el.querySelector('.'+accordionClass+'__head').addEventListener('click', (e) => {
        const nextEl = el.querySelector(this.trigger+'__content');
        if (el.classList.contains('active')) {
          Helper.slideClose(nextEl);
          el.classList.remove('active');
          nextEl.classList.remove('active');
        } else {
          el.classList.add('active');
          Helper.slideOpen(nextEl, true);
          nextEl.classList.add('active');
        }
      });
    });
  }
}

export default Accordion;
